import React, { forwardRef, memo } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { selectCurrentLanguage } from "../../../store/slices/languageSlice";
import Utils from "../../../../utils/Utils";
import { Parallax } from "react-scroll-parallax";
import _ from "lodash";

const TitleSimpleProps = forwardRef((props, ref) => {
  const { items, parent, options } = props;
  const lang = useSelector(selectCurrentLanguage);
  const cl = Utils.isValidJson(parent.className)
    ? JSON.parse(parent.className)
    : parent.className;

  const title =
    !_.isEmpty(options) && options?.title_lang && options?.title_lang[lang]
      ? options?.title_lang[lang]
      : parent?.title_lang && parent?.title_lang[lang];

  const subtitle =
    !_.isEmpty(options) &&
    options?.subtitle_widget &&
    options?.subtitle_widget[lang]
      ? options?.subtitle_widget[lang]
      : parent?.subtitle_widget && parent?.subtitle_widget[lang];

  return (
    <div>
      <Parallax
        className={
          "h-[350px] lg:h-[320px] md:h-[200px] sm:h-[200px] xs:h-[180px] flex items-center overflow-hidden relative  mt-[-82px] xs:mt-[0px] mb-[80px] md:mb-[60px] lg:mb-[60px] sm:mb-[60px]"
        }
        translateY={[-40, 40]}
        style={{
          backgroundImage:
            parent?.image_main &&
            `url(${Utils.formatURL(
              `posts/${parent?.post_content_id}/${parent?.image_main}`
            )}?s=md)`,
          backgroundSize: "cover",
          backgroundPosition: "center center",
          color: "#FFF",
          ...cl,
        }}
      >
        <div className="absolute h-full w-full opacity-50 top-0 left-0"></div>
        <Container>
          <Row className="items-center justify-center">
            <Col
              md={12}
              xl={12}
              lg={12}
              sm={12}
              className="relative text-center"
            >
              <h1 className="inline-block opacity-60 mb-[20px] text-xmd leading-[20px] -tracking-[.5px] font-serif  whitespace-pre-line">
                {subtitle}
              </h1>
              <h2 className="font-serif -tracking-[1px] text-[3.9rem] font-medium mb-0 sm:-tracking-[1px]">
                {title}
              </h2>
            </Col>
          </Row>
        </Container>
      </Parallax>
    </div>
  );
});

export default memo(TitleSimpleProps);
